export const COVEO_IGNORE_CLASS = "coveo-ignore";
